/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
export default {
  settings_changed: 'settings_changed',
  route_profile_setting_changed: 'route_profile_setting_changed',
  on_pause_time: 'on_pause_time',
  tapped_outside: 'tapped_outside',
  routeAloftReady: 'routeAloftReady',
  promiseProgress: 'promiseProgress',
  refreshView: 'refreshView.',
  refreshViewRootscope: 'refreshViewRootscope.',
  loadAirportHistory: 'loadAirportHistory',
  storeReady: 'storeReady',
  storeError: 'storeError',
  purchaseDone: 'purchaseDone',
  datasetSynced: 'datasetSynced',
  forceDevHttpError: 'forceDevHttpError',
  chartDrawComplete: 'chartDrawComplete',
  chartDrawStart: 'chartDrawStart',
  refreshImagery: 'refreshImagery',
  appResumeCheckAuth: 'appResumeCheckAuth',
  detachresize: 'detachresize',
  reattachresize: 'reattachresize',
  metFilterClosed: 'metFilterClosed',
  resetDepartureTime: 'resetDepartureTime',
  metchanged: 'metchanged',
  deviceSettingChanged: 'deviceSettingChanged',
  appPaused: 'appPaused',
  favorite: {
    loadFavorite: 'loadFavorite',
    listRefreshed: 'listRefreshed',
  },
  sliderEvent: {
    changing: 'changing',
    pinToggled: 'pinToggled',
  },
  menuevent: {
    enableDisableSwipe: 'enableDisableSwipe',
  },
  clockUtcChange: 'clockUtcChange',
  networkBackOnline: 'networkBackOnline',
  modalevent: {
    closeAirportForm: 'closeAirportForm',
    closeRouteForm: 'closeRouteForm',
    closeWorkshopInfo: 'closeWorkshopInfo',
    closeWorkshopPlayer: 'closeWorkshopPlayer',
    closeWorkshopFilter: 'closeWorkshopFilter',
    closeLoginForm: 'closeLoginForm',
    closeNoNetworkModal: 'closeNoNetworkModal',
    closeHelpBox: 'closeHelpBox',
    closeReportModal: 'closeReportModal',
    closeAirportSelector: 'closeAirportSelector',
    closeNeedSubscriptionModal: 'closeNeedSubscriptionModal',
    openEulaModal: 'openEulaModal',
    openNoNetworkConnectivity: 'openNoNetworkConnectivity',
    openReportModal: 'openReportModal',
  },
  radarImageLoaded: 'radarImageLoaded',
  tourEvent: 'tourEvent',
};
